/* eslint-disable prefer-const */
import get from 'lodash/get';
import React from 'react';
import { useSelector } from 'react-redux';

import { BQLink } from '../../../atoms/bqlink';
import MobileSearchBar from '../../../atoms/mobile-search-bar';
import SvgIcon from '../../../atoms/svg-icon';
import MemberMenu from '../../../molecules/member-menu/member-menu.js';
import './header-top.m.css';
import { watchLiveInteraction } from '../../../../helpers/datalayer-utils.js';
import { isMobile } from 'react-device-detect';
import { getUserStatus } from '../../../../helpers/utils';

const HeaderTop = (props) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const formattedPageType =
    pageType === 'story-page' ? 'story' : pageType === 'home-page' ? 'home-page' : 'section-page';

  const handleClick = (type, language = null) => {
    const baseData = {
      event: type === 'logo' ? 'logo_click' : 'language_selection',
      page_template: formattedPageType || 'NA',
      user_id: userData?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
      language_hit: 'english',
      Platform: isMobile ? 'mobile' : 'desktop',
      SiteName: 'www.ndtvprofit.com',
      ...(type === 'language' && {
        select_type: 'header',
        language_type: language,
      }),
    };

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(baseData);
    } else {
      console.error('Error: window.dataLayer is not available');
    }
  };

  return (
    <div styleName="header-top-container">
      <div styleName="header-top" className="container">
        <div styleName="mobile-search-with-language-toggle" className="mobile-only">
          <MobileSearchBar />
        </div>
        <div styleName="language-toggle" className="desktop-only">
          <div styleName="toggle-btn-container">
            <button
              styleName="toggle-btn toggle-selected"
              onClick={() => handleClick('language', 'english')}
            >
              English
            </button>
            <BQLink
              href="https://hindi.ndtvprofit.com?utm_source=profit&utm_medium=referral&utm_campaign=language"
              target="_blank"
              rel="noreferrer"
            >
              <button styleName="toggle-btn" onClick={() => handleClick('language', 'hindi')}>
                Hindi
              </button>
            </BQLink>
          </div>
        </div>
        <div onClick={() => handleClick('logo')}>
          <BQLink href="/?src=header">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="142.72"
              height="24.539"
              viewBox="0 0 142.72 24.539"
              style={{ width: '160px', height: '28px' }}
            >
              <defs>
                <style>{`
                  .a{fill:url(#a);}
                  .b{fill:url(#b);}
                  .c{fill:url(#c);}
                  .d{fill:url(#d);}
                  .e{fill:url(#e);}
                  .f{fill:#fff;}
                  .g{fill:#ec1d24;}
                `}</style>
                <linearGradient
                  id="a"
                  y1="0.5"
                  x2="3.942"
                  y2="0.5"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0.02" stop-color="#026ee0" />
                  <stop offset="0.08" stop-color="#0677e3" />
                  <stop offset="0.17" stop-color="#1190ec" />
                  <stop offset="0.29" stop-color="#24b9fb" />
                  <stop offset="0.3" stop-color="#26befd" />
                  <stop offset="0.35" stop-color="#3ab6fb" />
                  <stop offset="0.44" stop-color="#6ea2f8" />
                  <stop offset="0.57" stop-color="#c081f3" />
                  <stop offset="0.65" stop-color="#f76df0" />
                  <stop offset="0.92" stop-color="#f75ee3" />
                  <stop offset="0.97" stop-color="#dd5687" />
                </linearGradient>
                <linearGradient id="b" x1="-2.006" x2="4.859" xlinkHref="#a" />
                <linearGradient id="c" x1="-1.965" x2="2.362" xlinkHref="#a" />
                <linearGradient id="d" x1="-2.659" x2="1.186" xlinkHref="#a" />
                <linearGradient id="e" x1="-6.62" x2="0.142" xlinkHref="#a" />
              </defs>
              <g transform="translate(78.009 1.844)">
                <g transform="translate(0)">
                  <path
                    class="a"
                    d="M1406.672,51.47v6.281h-4.463V39.24h7.387a8.609,8.609,0,0,1,3.757.782,5.894,5.894,0,0,1,2.53,2.225,6.075,6.075,0,0,1,.9,3.273,5.357,5.357,0,0,1-1.939,4.329,8.045,8.045,0,0,1-5.321,1.621h-2.848Zm0-3.446h2.924a2.755,2.755,0,0,0,1.977-.649,2.409,2.409,0,0,0,.681-1.831,2.98,2.98,0,0,0-.7-2.073,2.478,2.478,0,0,0-1.907-.788h-2.974v5.34Z"
                    transform="translate(-1402.21 -37.956)"
                  />
                  <path
                    class="b"
                    d="M1621.1,99.852l-1.411-.1q-2.021,0-2.593,1.272v8.709h-4.285V95.974h4.018l.139,1.767a3.318,3.318,0,0,1,3.013-2.022,4.175,4.175,0,0,1,1.2.153l-.077,3.979Z"
                    transform="translate(-1596.029 -89.936)"
                  />
                  <path
                    class="c"
                    d="M1729.44,102.725a8.123,8.123,0,0,1,.8-3.668,5.729,5.729,0,0,1,2.3-2.473,6.931,6.931,0,0,1,3.521-.865,6.326,6.326,0,0,1,4.87,1.913,7.343,7.343,0,0,1,1.78,5.206v.153a7.122,7.122,0,0,1-1.786,5.1,7.169,7.169,0,0,1-9.554.127,6.89,6.89,0,0,1-1.92-4.774Zm4.284.267a5.116,5.116,0,0,0,.6,2.8,1.99,1.99,0,0,0,1.767.89q2.289,0,2.339-3.521v-.432q0-3.7-2.365-3.7-2.149,0-2.327,3.191l-.013.775Z"
                    transform="translate(-1703.365 -89.936)"
                  />
                  <path
                    class="d"
                    d="M1902.636,42.924V32.143h-2V29.168h2v-.457a5.252,5.252,0,0,1,1.806-4.208,7.212,7.212,0,0,1,4.691-1.373,16.673,16.673,0,0,1,4.475.737l-.585,3.382-.712-.19a11.344,11.344,0,0,0-2.924-.369q-2.454,0-2.453,2.238v.241h2.695v2.975h-2.695V42.924Zm12.942,0h-4.31V29.168h4.31Z"
                    transform="translate(-1860.923 -23.13)"
                  />
                  <path
                    class="e"
                    d="M2113.778,55.99v3.42h2.263v2.975h-2.263v6.293a1.6,1.6,0,0,0,.28,1.081,1.5,1.5,0,0,0,1.105.305,6.269,6.269,0,0,0,1.068-.076v3.064a7.916,7.916,0,0,1-2.416.369,4.489,4.489,0,0,1-3.267-1.042,4.275,4.275,0,0,1-1.054-3.166V62.385h-1.755V59.41h1.755V55.99h4.284Z"
                    transform="translate(-2051.521 -53.372)"
                  />
                </g>
              </g>
              <g transform="translate(0 0)">
                <g transform="translate(0 5.84)">
                  <path
                    d="M647.122,73.282h33.161c.016.029.034.058.049.088l4.955,9.373c.016.031.033.061.054.1.017-.033.03-.057.041-.08l3.678-7.385q.522-1.048,1.046-2.1h4.038c-.012.029-.022.058-.035.085q-3.2,6.347-6.39,12.694a.113.113,0,0,1-.119.071q-2.272,0-4.544,0a.131.131,0,0,1-.137-.082q-2.566-4.834-5.135-9.666a.116.116,0,0,0-.119-.074q-2.545,0-5.089,0h-.092v9.813h-3.754V76.318h-5.839c.006.027.01.047.015.066a7.758,7.758,0,0,1,.26,1.792c.015.6.021,1.21.014,1.816-.006.454-.022.909-.062,1.361a6.319,6.319,0,0,1-.5,1.969,4.333,4.333,0,0,1-2.211,2.3,6.025,6.025,0,0,1-2.319.509c-.112,0-.222.01-.334.015H647.124a.5.5,0,0,1-.014-.083v-12.7a.5.5,0,0,1,.014-.083Zm3.789,9.826h6.322a3.317,3.317,0,0,0,.841-.1,1.577,1.577,0,0,0,1.189-1.078,2.449,2.449,0,0,0,.115-.767c0-.967,0-1.933,0-2.9a2.537,2.537,0,0,0-.034-.418,1.669,1.669,0,0,0-1.04-1.339,2.754,2.754,0,0,0-1.089-.194h-6.22c-.027,0-.055,0-.083,0v6.791Z"
                    transform="translate(-629.271 -73.28)"
                  />
                  <path
                    d="M436.116,73.282h3.913V86.131h-4.068a4.753,4.753,0,0,1-2.259-.562,5.515,5.515,0,0,1-2.357-2.465c-.326-.643-.63-1.3-.945-1.946l-1.449-2.991a2.676,2.676,0,0,0-.4-.61,1.67,1.67,0,0,0-.8-.542,1.19,1.19,0,0,0-.448-.037v9.048c0,.038-.006.077-.008.116h-3.944c0-.033-.006-.067-.006-.1V73.381c0-.033,0-.067.006-.1h4.085l.076.009c.225.02.452.025.674.061a4.937,4.937,0,0,1,2.379,1.088,6.272,6.272,0,0,1,1.684,2.167c.693,1.44,1.376,2.885,2.061,4.328a4.477,4.477,0,0,0,.456.786,1.871,1.871,0,0,0,.768.641,1.2,1.2,0,0,0,.582.084V73.4c0-.041,0-.083,0-.124Z"
                    transform="translate(-423.331 -73.28)"
                  />
                  <path
                    class="f"
                    d="M423.247,73.3c0,.033-.006.067-.006.1V86.061c0,.033,0,.067.006.1-.006,0-.014,0-.015-.008,0-.021,0-.041,0-.062V73.37A.312.312,0,0,1,423.247,73.3Z"
                    transform="translate(-423.231 -73.298)"
                  />
                  <path
                    class="g"
                    d="M613.425,129.382h-.3c-.115-.018-.231-.031-.344-.056a2.35,2.35,0,0,1,1.027-4.587,2.375,2.375,0,0,1,1.8,2.671,2.312,2.312,0,0,1-1.824,1.911C613.671,129.347,613.548,129.362,613.425,129.382Z"
                    transform="translate(-595.989 -120.581)"
                  />
                </g>
                <path
                  d="M1308.666.77V23.75c-.005.028-.01.056-.014.084a.779.779,0,0,1-.555.665l-.1.031h-.592l-.124-.038a.8.8,0,0,1-.54-.79q.005-11.441,0-22.882c0-.026,0-.052,0-.078a.776.776,0,0,1,.536-.712l.124-.038H1308c.017.006.033.013.049.018a.754.754,0,0,1,.544.448,2.049,2.049,0,0,1,.078.315Z"
                  transform="translate(-1236.338 0.01)"
                />
              </g>
            </svg>
          </BQLink>
        </div>
        <div styleName="right-ctx">
          <div styleName="user-with-subscribe-btn">
            <MemberMenu {...props} />
          </div>
          <div
            styleName="live-tv-icon"
            className="mobile-only"
            onClick={() => watchLiveInteraction(userData, pageType, 'header')}
          >
            <BQLink href="/live-tv?src=topnav_livetv" styleName="live-icon" title="Live TV">
              <SvgIcon
                type="live_tv"
                iconStyle={{ width: '32px', height: '27px' }}
                source="image"
              />
            </BQLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
